import { classes } from '@theme/constants';
import { gsap } from '@theme/gsap';
import { isFromBreakpoint, withScrollTrigger } from '@theme/helpers';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';

class FeaturedStores extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.store) {
      this.on('mouseover', this.refs.store.all, this.handleStoreMouseOver.bind(this));
    }

    this.on('swiperslidechange', this.refs.slider, this.handleSlideChange.bind(this));

    this.on('swiperautoplaytimeleft', this.refs.slider, (event) => {
      this.handleSliderAutoplayTimeLeft(event);
      this.handleSlideChange({ detail: [this.refs.slider.swiper] });
    });

    /**
     * Entry animations.
     */
    if (this.refs.slider.swiper.autoplay.running) {
      this.refs.slider.swiper.autoplay.pause();
    }

    const timeline = withScrollTrigger(
      gsap.timeline().fromTo(
        [
          ...(this.querySelector('.featured-stores-slide__heading') ?? []),
          ...(isFromBreakpoint('large') ? [this.querySelector('.thumbnail-block')] : []),
        ],
        {
          autoAlpha: 0,
          y: '10%',
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: 0.5,
          stagger: 0.25,
        },
      ),
      this,
    );

    if (this.refs.store) {
      timeline.fromTo(
        this.refs.heading ? [this.refs.heading, ...this.refs.store.all] : this.refs.store.all,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          stagger: 0.125,
          onStart: (() => {
            if (this.refs.slider.swiper.autoplay.running) {
              setTimeout(() => {
                this.refs.slider.swiper.autoplay.resume();
              }, 250);
            }
          }).bind(this),
          onComplete: (() => {
            this.storesAnimationComplete = true;
          }).bind(this),
        },
        '<0.5',
      );
    }

    timeline.fromTo(
      this.refs.button,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      },
    );
  }

  /**
   * Handles the store mouse over event.
   * @param {MouseEvent} event - The mouse event.
   */
  handleStoreMouseOver(event) {
    if (this.storesAnimationComplete) {
      this.refs.slider.swiper.slideToLoop(Number(event.currentTarget.dataset.index0));
    }
  }

  /**
   * Handles the slider change event.
   * @param {Event} event - The event payload.
   * @param {object} event.detail
   */
  handleSlideChange({ detail: [swiper] }) {
    if (this.refs.store)
      for (const store of this.refs.store.all) {
        store.classList.toggle(classes.active, Number(store.dataset.index0) === swiper.realIndex);
      }
  }

  /**
   * Handles the slider autoplay time left event.
   * @param {Event} event - The event payload.
   * @param {object} event.detail
   */
  handleSliderAutoplayTimeLeft({ detail: [, , progress] }) {
    this.style.setProperty('--progress', `${((1 - progress) * 100).toFixed(1)}`);
  }

  onBlockSelect(event) {
    this.refs.slider.swiper.slideToLoop(Number(event.target.dataset.index0), 0);

    if (this.refs.slider.swiper.autoplay.running) {
      this.refs.slider.swiper.autoplay.pause();
    }
  }

  onBlockDeselect() {
    if (this.refs.slider.swiper.autoplay.running) {
      this.refs.slider.swiper.autoplay.resume();
    }
  }
}

if (!customElements.get('featured-stores')) customElements.define('featured-stores', FeaturedStores);
